import { render, staticRenderFns } from "./my_follow_list.vue?vue&type=template&id=75b20117"
import script from "./my_follow_list.vue?vue&type=script&lang=js"
export * from "./my_follow_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports